export default __webpack_public_path__ + "static/media/sc-bi-active-ico.08417a7b.svg";